import React from "react";
import { useIntl } from "react-intl";

import BreadCrumb from "@components/Breadcrumb";
import ProgressSpinner from "@components/ProgressSpinner";

import AdminContainer from "@layout/AdminContainer";

import { CancelDialog, CouponForm as CreateCouponForm } from "../components";
import { INITIAL_COUPON_DATA } from "../Coupons.constants";

import { BREADCRUMB_ITEMS } from "./CreateCoupon.constants";
import { useCreateCoupon } from "./CreateCoupon.hooks";
import CreateSchema from "./CreateCoupon.schema";

const CreateCoupon = () => {
  const { messages } = useIntl();

  const {
    headerConfig,
    isCancelDialogVisible,
    isLoading,
    handleCreateCoupon,
    handleOpenCancelDialog,
    handleCloseCancelDialog,
    handleCancelCouponCreation,
  } = useCreateCoupon();

  return (
    <AdminContainer config={headerConfig}>
      <BreadCrumb p={0} mb="12px" items={BREADCRUMB_ITEMS} />

      {isLoading && <ProgressSpinner />}

      <CreateCouponForm
        initialData={INITIAL_COUPON_DATA}
        validationSchema={CreateSchema}
        onSubmit={handleCreateCoupon}
        onCancel={handleOpenCancelDialog}
      />

      {isCancelDialogVisible && (
        <CancelDialog
          title={messages.title_cancel_creating_coupon}
          message={messages.message_are_you_sure}
          onConfirm={handleCancelCouponCreation}
          onHide={handleCloseCancelDialog}
        />
      )}
    </AdminContainer>
  );
};

export default CreateCoupon;
